(() => {
  const closeLabel = document.currentScript?.dataset.closeLabel || '';
  const css = "@media(max-width:749px){\n.pc-buttons-trigger-wrapper{display:none!important}\n.modal-card:has(.pc-campaign-267756){width:calc(100vw - 32px)!important;max-width:380px!important;max-height:calc(100dvh - 32px);overflow:visible!important}\n.pc-campaign-267756{padding:18px 16px!important;max-height:calc(100dvh - 76px);overflow-y:auto;overscroll-behavior:contain}\n.pc-campaign-267756 .text-block h1{font-size:22px!important;line-height:1.25!important;margin:0 0 10px!important}\n.pc-campaign-267756 .text-block p{font-size:13px!important;line-height:1.5!important;margin:0 0 14px!important}\n.pc-campaign-267756 input{font-size:16px!important;min-height:44px}\n.pc-campaign-267756 .submit-button{min-height:44px}\n.modal-card:has(.pc-campaign-267756) #pc-main-close-button{display:flex;align-items:center;justify-content:center;min-width:44px;min-height:44px}\n.cart-bar__product__title{font-size:12px;line-height:1.3}\n.cart-bar .product__submit__add{min-height:44px}\n}\n";
  const styleId = 'officina-mobile-newsletter';
  let observer;
  function adapt() {
    const root = document.getElementById('pop-convert-app')?.shadowRoot;
    if (!root) return;
    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = css;
      root.append(style);
    }
    const close = root.getElementById('pc-main-close-button');
    if (close && !close.dataset.officinaAccessible) {
      close.dataset.officinaAccessible = 'true';
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      if (closeLabel) close.setAttribute('aria-label', closeLabel);
      close.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          close.click();
        }
      });
    }
    if (!observer) {
      observer = new MutationObserver(adapt);
      observer.observe(root, { childList: true, subtree: true });
    }
  }
  adapt();
  const hostObserver = new MutationObserver(adapt);
  hostObserver.observe(document.body, { childList: true });
  let attempts = 0;
  const timer = setInterval(() => {
    adapt();
    attempts += 1;
    if (observer || attempts >= 30) clearInterval(timer);
  }, 1000);
})();
